import { Link as MuiLink } from "@mui/material";
import { Link as ReactRouterLink } from "react-router-dom";

export const Link = (props) => {
	return (
		<MuiLink
			{...props}
			component={ReactRouterLink}
			to={props.href ?? "#"}
			underline="none"
		/>
	);
};

export const SmartLink = ({ href, children, ...rest }) => {
	const isExternal = /^(https?:\/\/|mailto:|tel:)/.test(href);

	if (isExternal) {
		return (
			<MuiLink href={href} {...rest} underline="none">
				{children}
			</MuiLink>
		);
	}

	return (
		<Link href={href} {...rest}>
			{children}
		</Link>
	);
};
